import { gql } from '@apollo/client';

import { BusinessHoursFragmentDoc } from '../../../graphql/fragments/BusinessHours.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetAccountLocationQueryVariables = GraphQLTypes.Exact<{
  locationId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetAccountLocationQueryResult = { __typename?: 'Query' } & {
  accountLocation?: GraphQLTypes.Maybe<
    { __typename?: 'AccountLocation' } & Pick<
      GraphQLTypes.AccountLocation,
      'addressLabel' | 'id' | 'isArchived' | 'name' | 'usageContext'
    > & {
        account: { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>;
        address: { __typename?: 'Address' } & Pick<
          GraphQLTypes.Address,
          'city' | 'countyOrState' | 'line1' | 'line2' | 'postalCodeOrZip'
        > & { country?: GraphQLTypes.Maybe<{ __typename?: 'Country' } & Pick<GraphQLTypes.Country, 'code' | 'name'>> };
        businessHours?: GraphQLTypes.Maybe<
          { __typename?: 'BusinessHours' } & {
            monday?: GraphQLTypes.Maybe<{ __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>>;
            tuesday?: GraphQLTypes.Maybe<{ __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>>;
            wednesday?: GraphQLTypes.Maybe<{ __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>>;
            thursday?: GraphQLTypes.Maybe<{ __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>>;
            friday?: GraphQLTypes.Maybe<{ __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>>;
            saturday?: GraphQLTypes.Maybe<{ __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>>;
            sunday?: GraphQLTypes.Maybe<{ __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>>;
          }
        >;
        geolocation?: GraphQLTypes.Maybe<
          { __typename?: 'Geolocation' } & Pick<GraphQLTypes.Geolocation, 'latitude' | 'longitude'>
        >;
        permissions?: GraphQLTypes.Maybe<
          { __typename?: 'LocationPermissions' } & {
            canEditAddress?: GraphQLTypes.Maybe<
              { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
            >;
            canEditBusinessHours?: GraphQLTypes.Maybe<
              { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
            >;
            canEditDetails?: GraphQLTypes.Maybe<
              { __typename?: 'AuthorizationResult' } & Pick<GraphQLTypes.AuthorizationResult, 'value'>
            >;
          }
        >;
      }
  >;
};

export const GetAccountLocationDocument = gql`
  query getAccountLocation($locationId: String!) {
    accountLocation(locationId: $locationId) {
      account {
        id
        tradingName
      }
      address {
        city
        country {
          code
          name
        }
        countyOrState
        line1
        line2
        postalCodeOrZip
      }
      addressLabel
      businessHours {
        ...BusinessHours
      }
      geolocation {
        latitude
        longitude
      }
      id
      isArchived
      name
      permissions {
        canEditAddress {
          value
        }
        canEditBusinessHours {
          value
        }
        canEditDetails {
          value
        }
      }
      usageContext
    }
  }
  ${BusinessHoursFragmentDoc}
`;
